import APICall from "../utils/APICall"

export default class AppModServices {
    static listMod = async (page, pageLimit, search) => {
        return await APICall(`/api/ApplicationModule/admin/list-application-modules?page=${page}&pageLimit=${pageLimit}&search=${search}`, "GET")
    }
        static addPrimaryMailing = async (payload) => {
        return await APICall("/api/ApplicationModule/admin/add-primaryMailing-list", "POST", payload);
    }
    static addSecondaryMail = async (payload) => {
        return await APICall("/api/ApplicationModule/admin/add-secondaryMailing-list", "POST", payload);
    }

}